import { OutgoingMessageRequest } from "../messages/methods/message";
import { OutgoingRequestDelegate } from "../messages/outgoing-request";
import { OutgoingRequestMessage } from "../messages/outgoing-request-message";
import { NonInviteClientTransaction } from "../transactions/non-invite-client-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentClient } from "./user-agent-client";

/**
 * MESSAGE UAC.
 * @public
 */
export class MessageUserAgentClient extends UserAgentClient implements OutgoingMessageRequest {
  constructor(core: UserAgentCore, message: OutgoingRequestMessage, delegate?: OutgoingRequestDelegate) {
    super(NonInviteClientTransaction, core, message, delegate);
  }
}
